var routerActions = require('react-router-redux').routerActions;
var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var Symptom = (function() {

    var _requestSymptom = function(symptom) {
        return {
            type: constants.REQUEST_SYMPTOM
        };
    }

    var _receiveSymptom = function(data) {
        var symptom = data.symptom[0];
        if (symptom.webEducation) {
            symptom.education = symptom.webEducation;
        }
        return {
            type: constants.RECEIVE_SYMPTOM,
            data: symptom,
            receivedAt: Date.now()
        };
    }

    var _fetchSymptom = function(symptom) {
        return function(dispatch) {
            dispatch(_requestSymptom());
            return api.get('/proxy/v1/symptoms?friendlyurl=' + symptom).then(function(response) {
                return response;
            }).then(function(data) {
                return dispatch(_receiveSymptom(data));
            }).catch(function(error){
                if(error.response){
                    dispatch(commonActions.setGenericResponseError('', error.response));
                }else{
                    dispatch(commonActions.setGenericError('', error.message));
                }
            });
        };
    }

    var _shouldFetchSymptom = function(state, friendlyUrl) {
        var symptom = state.symptom;
        if (Object.keys(symptom).length === 0) {
            return true;
        } else if (symptom.items && symptom.items.friendlyUrl === friendlyUrl) {
            return false;
        } else {
            return true;
        }
    }

    var _fetchSymptomIfNeeded = function(symptom) {
        return function(dispatch, getState) {
            if (_shouldFetchSymptom(getState(), symptom)) {
                return dispatch(_fetchSymptom(symptom))
            }
        }
    }

    const _setSymptom = function (symptom) {
        return {
          type: constants.SET_SYMPTOM,
          data: symptom,
        };
      };

    const _createSymptomRequest = function () {
      return {
        type: constants.CREATE_SYMPTOM_REQUEST,
      };
    };

    const _createSymptomSuccess = function (data) {
      return {
        type: constants.CREATE_SYMPTOM_SUCCESS,
        data: data.symptom,
      };
    };

    const _createSymptomError = function (error) {
      return {
        type: constants.CREATE_SYMPTOM_ERROR,
        errors: error.data,
      };
    };

    const _updateSymptomRequest = function () {
      return {
        type: constants.UPDATE_SYMPTOM_REQUEST,
      };
    };

    const _updateSymptomSuccess = function (data) {
      return {
        type: constants.UPDATE_SYMPTOM_SUCCESS,
        data: data.symptom,
      };
    };

    const _updateSymptomError = function (error) {
      return {
        type: constants.UPDATE_SYMPTOM_ERROR,
        errors: error.data,
      };
    };

    var _createSymptom = function(symptom, type = 'gi', token) {
      return function (dispatch) {
        dispatch(_createSymptomRequest(symptom));
        api.post(`/proxy/v1/symptoms/${type}`, symptom, token)
        .then(function(data) {
          const { symptom: { friendlyUrl = '' } } = data;
          const redirect = (friendlyUrl) ? `/education/symptoms/${friendlyUrl}` : '/education/';
          dispatch(_createSymptomSuccess(data));
          dispatch(routerActions.replace(redirect));
        })
        .catch(function(error) {
            if (error.response){
                dispatch(_createSymptomError(error.response));
            } else {
                dispatch(commonActions.setGenericError('', error.message));
            }
        })
      };
    }

    var _updateSymptom = function(symptom, token) {
      return function (dispatch) {
        // Note 'id' and not '_id' on this one!
        const { id: symptomId } = symptom;
        dispatch(_updateSymptomRequest());
        api.put(`/proxy/v1/symptoms/${symptomId}`, symptom, token)
        .then(function(data) {
          const { symptom: { friendlyUrl = '' } } = data;
          const redirect = (friendlyUrl) ? `/education/symptoms/${friendlyUrl}` : '/education/';
          dispatch(_updateSymptomSuccess(data));
          dispatch(routerActions.replace(redirect));
        })
        .catch(function(error) {
            if (error.response){
                dispatch(_updateSymptomError(error.response));
            } else {
                dispatch(commonActions.setGenericError('', error.message));
            }
        })
      };
    }

    return {
        requestSymptom: _requestSymptom,
        receiveSymptom: _receiveSymptom,
        fetchSymptom: _fetchSymptom,
        shouldFetchSymptom: _shouldFetchSymptom,
        fetchSymptomIfNeeded: _fetchSymptomIfNeeded,
        setSymptom: _setSymptom,
        createSymptom: _createSymptom,
        updateSymptom: _updateSymptom
    }
})();

module.exports = Symptom;



// WEBPACK FOOTER //
// ./src/common/modules/education/actions/symptom.js